export default __webpack_public_path__ + "static/media/banner.21d1376a.jpg";